// src/data/status.ts — Estados alterados originales de Aetheria
export type StatusDef = {
  id: string;
  name: string;
  description: string;
  duration: number; // turnos
  onTurn?: (unit:any)=> { damage?:number; skip?:boolean; message?:string };
  modifiers?: { atk?: number; def?: number; spd?: number; acc?: number };
};

export const STATUSES: Record<string, StatusDef> = {
  ralentizado: {
    id:'ralentizado', name:'Ralentizado', description:'-30% velocidad 3 turnos.',
    duration:3, modifiers:{ spd: -0.3 }
  },
  debilitado: {
    id:'debilitado', name:'Debilitado', description:'-25% ataque 3 turnos.',
    duration:3, modifiers:{ atk: -0.25 }
  },
  confusion: {
    id:'confusion', name:'Confusión', description:'30% de fallar el turno 2 turnos.',
    duration:2, onTurn: ()=> Math.random()<0.30 ? { skip:true, message:'¡Confundido! Falló.' } : {}
  },
  interferencia: {
    id:'interferencia', name:'Interferencia', description:'-20% precisión 3 turnos.',
    duration:3, modifiers:{ acc: -0.2 }
  },
  agotamiento: {
    id:'agotamiento', name:'Agotamiento', description:'-1 energía por turno 3 turnos.',
    duration:3, onTurn: (unit)=> ({ message:'Agotado pierde energía' })
  },
  enraizado: {
    id:'enraizado', name:'Enraizado', description:'No puede cambiar y cura 5% cada turno.',
    duration:4, onTurn: (unit)=> ({ damage: -Math.floor(unit.maxHp*0.05), message:'Enraizado cura' })
  },
};

export function getStatus(id:string): StatusDef | undefined { return STATUSES[id]; }
